import enUS from './assets/i18n/en-US.json'
import zhCN from './assets/i18n/zh-CN.json'
import zhTW from './assets/i18n/zh-TW.json'

const trData = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
}

export { trData }



// WEBPACK FOOTER //
// ./src/i18n-import.js